import React from "react";
import { AddImage } from "./AddImage";

export const ToolBar = ({ editor }) => {
  if (!editor) return null;

  return (
    <div className="menu-bar justify-content-between">
      <div className="d-flex flex-row" style={{ "flexWrap": "wrap" }}>
        <button
          onClick={() => editor.chain().focus().toggleBold().run()}
          className={editor.isActive("bold") ? "is_active" : ""}
        >
          <i className="fa-duotone fa-bold" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleItalic().run()}
          className={editor.isActive("italic") ? "is_active" : ""}
        >
          <i className="fa-duotone fa-italic" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleUnderline().run()}
          className={editor.isActive("underline") ? "is_active" : ""}
        >
          <i className="fa-duotone fa-underline" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleStrike().run()}
          className={editor.isActive("strike") ? "is_active" : ""}
        >
          <i className="fa-duotone fa-strikethrough" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
          className={editor.isActive("heading", { level: 2 }) ? "is_active" : ""}
        >
          <i className="fa-duotone fa-h2" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
          className={editor.isActive("heading", { level: 3 }) ? "is_active" : ""}
        >
          <i className="fa-duotone fa-h3" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleBulletList().run()}
          className={editor.isActive("bulletList") ? "is_active" : ""}
        >
          <i className="fa-duotone fa-list" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleOrderedList().run()}
          className={editor.isActive("orderedList") ? "is_active" : ""}
        >
          <i className="fa-duotone fa-list-ol" />
        </button>
        <button
          onClick={() => editor.chain().focus().toggleBlockquote().run()}
          className={editor.isActive("blockquote") ? "is_active" : ""}
        >
          <i className="fa-duotone fa-quote-right" />
        </button>
       
        <AddImage editor={editor} />
      </div>
      <div className="d-flex flex-row">
        <button onClick={() => editor.chain().focus().undo().run()}>
          <i className="fa-duotone fa-rotate-left" />
        </button>
        <button onClick={() => editor.chain().focus().redo().run()}>
          <i className="fa-duotone fa-rotate-right" />
        </button>
      </div>
    </div>
  );
};
